import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { MutatePoetDTO } from "../../dto";

type CreatePoetProps = {
  youngAvatar: File;
  oldAvatar: File;
  idleAnimation: File;
  happyAnimation: File;
  name: string;
};

let body: MutatePoetDTO;

export async function createPoetAction(props: CreatePoetProps) {
  const token = localStorage.getItem("token");

  const params = new FormData();
  params.append("youngAvatar", props.youngAvatar);
  params.append("oldAvatar", props.oldAvatar);
  params.append("idleAnimation", props.idleAnimation);
  params.append("happyAnimation", props.happyAnimation);
  params.append("name", props.name);

  return await axios
    .post(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/poets/create`,
      params,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "app-platform": "cms",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(async (res) => {
      body = plainToClass(MutatePoetDTO, res.data);
      await validate(body);
      const errors = await validate(body);
      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
